import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Dark class is applied synchronously by the inline <script> in <head>
    // to prevent FOUC. No action needed here.
  }

  toggle(e) {
    if (e) e.preventDefault();

    if (document.documentElement.classList.contains("dark")) {
      document.documentElement.classList.remove("dark");
      localStorage.theme = "light";
    } else {
      document.documentElement.classList.add("dark");
      localStorage.theme = "dark";
    }
  }
}
